enum ROUTE {
    HOME = 'Home',
    AUTH = 'Auth',
    PROFILE = 'Profile',
    USERS = 'Users',
    FACTURATIONS = 'Facturations',
    SUIVICA = 'SuiviCA',
    SUIVICONSO = 'SuiviConso',
    REGISTRATION = 'Registration',
    FORMULAIRE = 'Formulaires',
    ETATSTOCK = 'Etat du stock',
    PMNADMINISTRATION = 'PMN Modèles',
    PMNCLIENT = 'PMN Client',
    PMNBIOBANK = 'PMN Biobank',
    GED = 'GED',
    PDF = 'PDF',
    EVENEMENTS = 'EVENEMENTS',
    FORMULAIRE_REPONSES = 'FORMULAIRE_REPONSES',
    FORMULAIRE_REPONSES_ADMIN = 'FORMULAIRE_REPONSES_ADMIN',
    INVENTAIRES = 'INVENTAIRES',
    COMMANDES = 'COMMANDES',
    FICHE_IMPLANTATION = 'FICHE_IMPLANTATION',
    FICHE_IMPLANTATION_ADMIN = 'FICHE_IMPLANTATION_ADMIN',
    PRODUIT_ADMIN = 'PRODUIT_ADMIN',
    URLAPPINVENTAIRE = 'URLAPPINVENTAIRE',
    IMPORT_ROTATION_PRODUITS = 'IMPORT_ROTATION_PRODUITS',
    SUIVI_RECUEIL = 'SUIVI_RECUEIL',
    RESETPASSWORD = 'RESETPASSWORD',
    KITS = "KITS",
    PRETS = "PRETS",
    ACTUALITES = "ACTUALITES"
}

export default ROUTE
